import { ThemeName, getThemeConfig, ThemeConfig } from "./ThemeConfig";

export const TILE_SIZE = 80;
export const MAP_SIZE = 13;

/**
 * タイルの種類
 */
export type TileType = "floor" | "wall";

/**
 * タイルマップを管理するクラス
 *
 * 純粋なロジック層: タイルの配置管理と移動判定のみ。
 * 描画は TileMapRenderer が担当。
 */
export class TileMap {
  private tiles: TileType[][];
  private themeConfig: ThemeConfig;

  constructor(theme: ThemeName = "cave") {
    this.themeConfig = getThemeConfig(theme);
    this.tiles = this.createDefaultTiles();
  }

  /**
   * デフォルトのタイル配置を生成（すべて床）
   */
  private createDefaultTiles(): TileType[][] {
    const tiles: TileType[][] = [];
    for (let y = 0; y < MAP_SIZE; y++) {
      tiles[y] = [];
      for (let x = 0; x < MAP_SIZE; x++) {
        tiles[y][x] = "floor";
      }
    }
    return tiles;
  }

  /**
   * 指定座標のタイルを設定
   */
  setTile(x: number, y: number, type: TileType): void {
    if (x >= 0 && x < MAP_SIZE && y >= 0 && y < MAP_SIZE) {
      this.tiles[y][x] = type;
    }
  }

  /**
   * 指定座標が移動可能かどうか
   */
  isWalkable(x: number, y: number): boolean {
    if (x < 0 || x >= MAP_SIZE || y < 0 || y >= MAP_SIZE) {
      return false;
    }
    return this.tiles[y][x] === "floor";
  }

  /**
   * タイル配列を取得（Rendererが描画に使用）
   */
  getTiles(): readonly (readonly TileType[])[] {
    return this.tiles;
  }

  /**
   * テーマ設定を取得（Rendererが描画に使用）
   */
  getThemeConfig(): ThemeConfig {
    return this.themeConfig;
  }
}
